import React, { useState, useEffect } from 'react';

import { PProFetch } from '../ajax';
import Sidebar from './Sidebar';
import AccordianItem from './AccordianItem';
import PasswordChange from './PasswordChange';
import OpenInvoices from './OpenInvoices';
import RecentOrders from './RecentOrders';

export default function Dashboard() {

	const [fpInfo, setFpInfo] = useState({
		root: {
			"CacheKey": null,
			"ShowOrderImportLink": null,
			"ShowInvoicePaymentLink": null,
			"ShowSRPLink": null,
			"ShowProductCatalogMenu": null,
			"ShowContactMaintLink": null,
			"ShowReportsLink": null,
			"ShowChangePasswordLink": null,
			"ShowStandingOrderLink": null,
			"ShowBroadcastMessageLink": null,
			"ShowCompanySelectionLink": null,
			"CompanySelectionLink": null,
			"ShowCustomerBalance": null,
			"ShowTerms": null,
		},
		rowData: {
			/* nothing */
		}
	});

	const [loading, setLoading] = useState(true);

	const updateStateFromAjax = (json) => {
		setFpInfo({...json});
		setLoading(false);
	}

	useEffect(() => {
		setLoading(true);
		PProFetch("command=AccountDashboardHandler.getconfig")
		.then(response => {
			return response.json();
		})
		.then(json => {
			updateStateFromAjax(json);
		});
	}, []);

	const outputContactMaintAccordian = () => {
		if (loading) return null;
		const bChangePswd = fpInfo.root.ShowChangePasswordLink?.value === "true";
		const bContMaint = fpInfo.root.ShowContactMaintLink?.value === "true";
		if (!bChangePswd && !bContMaint) {
			return null;
		}
		return (
			<AccordianItem className="when-cxml-hide" name="my_account" title="My Account" collapsed>
				{ bChangePswd ? (
					<PasswordChange />
				) : null }
				{ bContMaint ? (
					<React.Fragment>
						<hr />
						<div className="d-flex justify-content-end mt-3">
							<a href="command=ContactHandler.list" className="button">Manage My Contacts</a>
						</div>
					</React.Fragment>
				) : null }
			</AccordianItem>
		);
	}

	return (
		<section className="">
			<div className="section__inner">
				<div className="w-1200px m-auto">
					<div className="justify-content-between align-items-center mb-md1">
						<h2 className="font-size--xl font-weight--800 text-color--gray5">My Account Dashboard</h2>
					</div>
					<div className="d-md-flex">
						{ loading ? null : (
							<Sidebar CacheKey={fpInfo.root.CacheKey.value}
								ReportsLink={fpInfo.root.ShowReportsLink.value}
								ShowOrderImportLink={fpInfo.root.ShowOrderImportLink.value}
								ShowSRPLink={fpInfo.root.ShowSRPLink.value}
								ShowStandingOrderLink={fpInfo.root.ShowStandingOrderLink.value}
								ShowBroadcastMessageLink={fpInfo.root.ShowBroadcastMessageLink.value}
								ShowCompanySelectionLink={fpInfo.root.ShowCompanySelectionLink.value}
								CompanySelectionLink={fpInfo.root.CompanySelectionLink.value}
								ShowCustomerBalance={fpInfo.root.ShowCustomerBalance.value}
								ShowTerms={fpInfo.root.ShowTerms.value}
							/>
						) }
						<div className="col ms-md-md3">
							{ loading ? null : (
								<div className="accordion" id="account_modules">
									<AccordianItem name="order_history" title="Order History" refreshable>
										<RecentOrders CacheKey={fpInfo.root.CacheKey.value} />
										<hr />
										<div className="d-flex justify-content-end mt-3">
											<a href="command=orderstatus" className="button">Search Order History</a>
										</div>
									</AccordianItem>
									{ fpInfo.root.ShowInvoicePaymentLink.value === "true" ? (
										<AccordianItem name="open_invoices" title="Open Invoices" refreshable collapsed>
											<OpenInvoices CacheKey={fpInfo.root.CacheKey.value} />
											<div className="d-flex justify-content-end mt-3">
												<a href="command=InvoicePayment.options" className="button">Pay Invoices</a>
											</div>
										</AccordianItem>
									) : null }
									{ outputContactMaintAccordian() }
								</div>
							) }
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}